import React from 'react'
import { VictoryPie } from 'victory'

const PieChart = props => {
  return <VictoryPie {...props} />
}

export default PieChart



// WEBPACK FOOTER //
// ./src/charts/PieChart.js